import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { RegisterActivity } from '../../app/models/RegisterActivity';
import { HttpErrorResponse } from '@angular/common/http';
import { TableDirective } from '../../directives/table-directive';
import { User } from '../../app/models/User';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { Storage } from '../../../node_modules/@ionic/storage';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'page-register-activity-details',
  templateUrl: 'register-activity-details.html',
})
export class RegisterActivityDetailsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  private pageName: string = 'page-customer-details';
  private registerActivityUuid: string;
  private currentActivity: RegisterActivity;
  private openingOperator: User;
  private closingOperator: User;
  private navControllerService: NavControllerService;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private app: App,
    private storage: Storage,
    private userService: UserService
  ) {
    this.navControllerService = new NavControllerService(app, storage);
    this.registerActivityUuid = this.navParams.get('registerActivityUuid');
    this.currentActivity = new RegisterActivity();
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.loadRegisterActivity();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  private loadRegisterActivity() {
    this.backendService.getRegisterActivity(this.registerActivityUuid).subscribe(
      (data: RegisterActivity) => {
        this.currentActivity = data;
        this.getOpeningOperator(data.openingOperator.uuid);
        if (data.closeDate) {
          this.getClosingOperator(data.closingOperator.uuid);
        } else {
          this.backendService.calculateRegisterActivity(data).subscribe(
            (calculated: RegisterActivity) => {
              this.currentActivity = calculated;
            },
            (err: HttpErrorResponse) => {}
          );
        }
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private getOpeningOperator(operatorUuid) {
    this.userService.getUser(operatorUuid).subscribe(
      (user: User) => {
        this.openingOperator = user;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private getClosingOperator(operatorUuid) {
    this.userService.getUser(operatorUuid).subscribe(
      (user: User) => {
        this.closingOperator = user;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showRegisterActivitiesPage() {
    this.navControllerService.showRegisterActivitiesPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/register-activity-details/register-activity-details.ts